import { useCallback, useEffect, useState } from "react";
import api from "../api";
import TablePagination from "../components/TablePagination";

const formatDate = (value) => value ? new Date(value).toLocaleDateString("en-IN") : "—";
const PAGE_SIZE = 25;

export default function VehicleMisPage() {
  const [vehicles, setVehicles] = useState([]);
  const [query, setQuery] = useState("");
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const response = await api.get("/vehicles", { params: { query, page, limit: PAGE_SIZE } });
      setVehicles(response.data.data || []);
      setCount(Number(response.data.count) || 0);
      setError("");
    } catch (err) {
      setError(err.response?.data?.message || "Unable to load vehicle data.");
    } finally {
      setLoading(false);
    }
  }, [query, page]);

  useEffect(() => { load(); }, [load]);
  const exportCsv = () => {
    const headers = ["Vehicle Number", "Vehicle Type", "Fuel Type", "Load Capacity", "Vendor", "Created Date"];
    const csv = [headers, ...vehicles.map((vehicle) => [vehicle.vehicleNumber, vehicle.vehicleType, vehicle.fuelType, `${vehicle.loadCapacity} ${vehicle.loadCapacityUnit}`, vehicle.vendorName, formatDate(vehicle.createdAt)])].map((row) => row.map((value) => `"${String(value ?? "").replaceAll('"', '""')}"`).join(",")).join("\n");
    const link = document.createElement("a");
    link.href = URL.createObjectURL(new Blob([csv], { type: "text/csv;charset=utf-8" }));
    link.download = `vehicle-mis-page-${page}-${new Date().toISOString().slice(0, 10)}.csv`;
    link.click();
    URL.revokeObjectURL(link.href);
  };

  return <div className="vehicle-mis"><div className="vehicle-mis-heading"><div><p>MIS REPORTS</p><h2>Vehicle MIS</h2><span>Live vehicle master report for your company fleet.</span></div></div><section><div className="vehicle-mis-tools"><input value={query} onChange={(event) => { setQuery(event.target.value); setPage(1); }} placeholder="Search vehicle number" aria-label="Search report" /><button type="button" onClick={exportCsv}>Export This Page</button><button type="button" onClick={load}>Refresh</button></div>{loading ? <p>Loading vehicle MIS…</p> : error ? <p className="fuel-error">{error}</p> : <><div className="vehicle-mis-table"><table><thead><tr>{["Sl", "Vehicle Number", "Vehicle Type", "Fuel Type", "Load Capacity", "Vendor", "Created Date"].map((column) => <th key={column}>{column}</th>)}</tr></thead><tbody>{vehicles.map((vehicle, index) => <tr key={vehicle._id}><td>{(page - 1) * PAGE_SIZE + index + 1}</td><td>{vehicle.vehicleNumber}</td><td>{vehicle.vehicleType}</td><td>{vehicle.fuelType}</td><td>{vehicle.loadCapacity} {vehicle.loadCapacityUnit}</td><td>{vehicle.vendorName}</td><td>{formatDate(vehicle.createdAt)}</td></tr>)}{!vehicles.length && <tr><td colSpan="7">No vehicle records found.</td></tr>}</tbody></table></div><TablePagination page={page} setPage={setPage} total={count} pageSize={PAGE_SIZE} label="Vehicle records" /></>}</section></div>;
}
